import style from "./style.module.sass"
import {useStores} from "../../../../hooks";
import {observer} from "mobx-react";
import PriceComponent from "../../../../components/priceComponent";
import {FlexRowSpaceBetween} from "../../../../components/containers/containers";
import {useHistory} from "react-router-dom";
import {isEmbedded} from "../../../../utils/embed";
import {useTranslation} from "react-i18next";

const ToCheckoutButton = () => {
    const {cartStore, menuStore, generalStore} = useStores();
    const history = useHistory();
    const {t} = useTranslation(['general', 'menu'])
    const buttonsColor = menuStore.menu?.data?.themeSettings?.buttonsBackgroundColor


    const isOpen = !cartStore.isCartEmpty() && cartStore.menuId === menuStore.menu.id;

    if(!isOpen) return null;
    const price = cartStore.getTotal();


    return <div className={style.toCheckoutContainer}>
        <div className={style.button} style={{background: buttonsColor || '#FF2C3D'}} onClick={() => {
            // Во встроенном режиме не добавляем запись в общую историю вкладки — см. utils/embed.
            isEmbedded() ? history.replace("/cart") : history.push("/cart");
            window.scrollTo(0, 0);
        }}>
            <FlexRowSpaceBetween>
                <span className={style.text}>
                    {generalStore.viewOnly ? t('menu:confirmOrderViewOnly') : t('menu:confirmOrder')}
                </span>
                <PriceComponent item={{
                    currencyId: "RUB",
                    price: price
                }}/>
            </FlexRowSpaceBetween>
        </div>
    </div>
};

export default observer(ToCheckoutButton);
